import React from "react";
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers'
import moment from "moment";

export default function DateInput(props) {

    const { errors, label, fullWidth, calenderOpen, setCalenderOpen, variant, inputVariant, ...datePickerProps } = props;

    return (
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <KeyboardDatePicker
                onClick={() => setCalenderOpen(true)}
                onOpen={() => setCalenderOpen(true)}
                onClose={() => setCalenderOpen(false)}
                open={calenderOpen}
                autoOk
                variant={variant ? variant : "inline"}
                {...datePickerProps}
                inputVariant={inputVariant ? inputVariant : "filled"}
                label={label}
                fullWidth={(fullWidth != undefined) ? fullWidth : true}
                error={!!errors}
                helperText={errors && errors.message}
            />
        </MuiPickersUtilsProvider>
    )
}

DateInput.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    variant: PropTypes.string,
    inputVariant: PropTypes.string,
    errors: PropTypes.object,
    calenderOpen: PropTypes.bool,
    setCalenderOpen: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/DateInput.js